import { IzIntegrationNirvanaDataProvider } from '../dataProvider/IzIntegrationNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';

export class IzIntegrationDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, IzIntegrationNirvanaDataProvider);
  }
}
